// extracted by mini-css-extract-plugin
export default {"title":"PFxxeJpzjq3_2aJ3z8Ww","item":"Xmr8VQKEx9w5VNvB0yPR","error":"ggo2EkqyatLY9xbI6Loe","btn":"xGk6ANRWYWSXFP_eqGHr"};